/**
 * 将当前页面的页面名称、模块名称、位置信息记录下来，传递到下一个页面去
 * @Author: moonye
 * @Date: 2018-06-26 17:08:48
 * @Last Modified by: moonye
 * @Last Modified time: 2020-03-09 21:42:35
 */
import positionHandler from './positionHandler';
import injectUtil from './util.inject';
import util from './util';

/**
 * 拦截点击请求，并获取跟点击元素相关的 module 和 position
 * @param {object} data 上报相关数据
 * @param {object} opts.quite 控制上报相关的参数，比如 quite 为 true，表示通过 cookie 的方式在页面间传值
 */
let reportInstance;

const clickHandler = (finalTarget) => {
  const positionDom = util.closest(finalTarget, '[data-report-position]');
  const moduleDom = util.closest(finalTarget, '[data-report-module]');

  const reportPosition = encodeURIComponent(positionDom && positionDom.getAttribute('data-report-position') || '');
  const reportModule = encodeURIComponent(moduleDom && moduleDom.getAttribute('data-report-module') || '');

  positionHandler.setPositionData(
    {
      url_position: reportPosition,
      url_module: reportModule,
      url_page: encodeURIComponent(reportInstance && reportInstance.getReportData('page') || '')
    }
  );
};
// }

/**
 * position 中的值都是来源于上一个页面，这个不能从 cookie 中取
 * @param {*} dataFromCookie
 * @param {*} report
 */
export default function (dataFromCookie, report) {
  reportInstance = report;

  injectUtil.addListener(clickHandler);

  const positionData = positionHandler.getPositionData() || {};
  ['url_page', 'url_module', 'url_position'].forEach(item => {
    dataFromCookie[item] = positionData[item] || '';
  });
  return dataFromCookie;
};
